import { render, staticRenderFns } from "./save.vue?vue&type=template&id=64e99bc2&scoped=true&"
import script from "./save.vue?vue&type=script&lang=js&"
export * from "./save.vue?vue&type=script&lang=js&"
import style0 from "./save.vue?vue&type=style&index=0&id=64e99bc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e99bc2",
  null
  
)

export default component.exports